import antdEn from "antd/lib/locale-provider/en_US";

import enMessages from "../locales/en_US.json";
import enTranslatedMessages from "../locales/en_US_translated.json";
import enMigratedMessages from "../locales/en_US_migrated.json";

import enDescMessages from "../locales/desc_en_US.json";
import enDescTranslatedMessages from "../locales/desc_en_US_translated.json";
import enDescMigratedMessages from "../locales/desc_en_US_migrated.json";

import d3enUS from "d3-format/locale/en-US";

const EnLang = {
  messages: {
    ...enMessages,
    ...enDescMessages,
    ...enMigratedMessages,
    ...enDescMigratedMessages,
    ...enTranslatedMessages,
    ...enDescTranslatedMessages,
  },
  antd: antdEn,
  locale: "en-US",
  moment: "en",
  numeral: "en",
  d3: d3enUS,
  label: "English",
  app: "en",
};
export default EnLang;
